import Attrs from '../models/Attrs'
import type { ChildFlow, Flow, FlowPage } from '../models/types'

const CONTROLLER = 'components--child-flow'

export default function renderChildFlow(
  component: ChildFlow,
  attrs: Attrs,
  page: FlowPage,
  flow: Flow,
  editingMode: boolean
): string {
  attrs
    .addController(CONTROLLER)
    .addValueIfExists(CONTROLLER, 'popup-mode', component.popup_mode)
    .addValueIfExists(CONTROLLER, 'id', component.flow_id)

  const componentAttrs = `data-components--child-flow-attributes-value=${JSON.stringify(
    component.attributes || {}
  )}`
  const savvyAttrs = new Attrs(attrs.static_render)
    .addTarget(CONTROLLER, 'savvy')
    .add('id', component.flow_id)
    .add('popup-mode', String(!!component.popup_mode))

  //* Add template controller if the id has {{
  if (component.flow_id && component.flow_id.includes('{{'))
    savvyAttrs.addController('template').addValue('template', 'target', 'id')

  if (component.view_only) savvyAttrs.add('view-only', String(!!component.view_only))

  if (component.attributes)
    Object.entries(component.attributes || {}).forEach(([key, val]) => savvyAttrs.add(key, val))

  return `<div ${componentAttrs} ${attrs}><savvy ${savvyAttrs}></savvy></div>`
}
